import React from 'react'
import { RangeFragment } from '../../src/model/fragments'
import { Range } from './Range'

export const SizeAttributeRange: React.FC<{ 
	onChange: (range: RangeFragment | null) => void,
	selected: RangeFragment | null,
	range: RangeFragment
}> = 
(props) => (
	<Range
		{...props}
		sliderProps={{ suffix: ' mm' }}
	/>
)
